module.exports = __webpack_public_path__ + "static/media/examplebank.435fef20.svg";